import type { TranslationKey } from "@privacy/translations";
import {
  getGridNumericOperators,
  gridNumberComparator,
  type GridColDef,
  type GridValidRowModel,
} from "@mui/x-data-grid-premium";
import { Stack, Typography } from "@mui/material";
import { DynamicGrid } from "../dynamicGrid";
import { EmptyCell } from "../dynamicGrid/columnDefinitions";
import type { Criticality } from "./schemas";

export const criticalityColumn = <Row extends GridValidRowModel>(
  t: (key: TranslationKey) => string,
  getCriticality: (row: Row) => Criticality | null | undefined
): GridColDef<Row> => ({
  ...DynamicGrid.requiredColDef({ field: "criticality", headerName: t("Classification.Grid.CriticalityHeader") }),
  minWidth: 120,
  width: 130,
  valueGetter: (_, row) => getCriticality(row)?.value ?? null,
  sortComparator: gridNumberComparator,
  filterOperators: getGridNumericOperators(),
  renderCell: ({ row }) => {
    const criticality = getCriticality(row);
    return (
      <DynamicGrid.Cell withExtraSpacingTop={false}>
        <Stack sx={{ alignItems: "center", justifyContent: "center" }}>
          {criticality ? (
            <Typography
              sx={{
                fontWeight: 600,
                fontSize: theme => theme.typography.pxToRem(14),
                color: theme => theme.palette.text.secondary,
              }}
            >
              {criticality.value}
            </Typography>
          ) : (
            <EmptyCell />
          )}
        </Stack>
      </DynamicGrid.Cell>
    );
  },
});
